export const chargeConstants = {
  // Fetch all charges
  CHARGES_FETCH_REQUEST: 'CHARGES_FETCH_REQUEST',
  CHARGES_FETCH_SUCCESS: 'CHARGES_FETCH_SUCCESS',
  CHARGES_FETCH_FAILURE: 'CHARGES_FETCH_FAILURE',

  // Create a charge
  CHARGE_CREATE_REQUEST: 'CHARGE_CREATE_REQUEST',
  CHARGE_CREATE_SUCCESS: 'CHARGE_CREATE_SUCCESS',
  CHARGE_CREATE_FAILURE: 'CHARGE_CREATE_FAILURE',

  // Update a charge
  CHARGE_UPDATE_REQUEST: 'CHARGE_UPDATE_REQUEST',
  CHARGE_UPDATE_SUCCESS: 'CHARGE_UPDATE_SUCCESS',
  CHARGE_UPDATE_FAILURE: 'CHARGE_UPDATE_FAILURE',

  // Delete a charge
  CHARGE_DELETE_REQUEST: 'CHARGE_DELETE_REQUEST',
  CHARGE_DELETE_SUCCESS: 'CHARGE_DELETE_SUCCESS',
  CHARGE_DELETE_FAILURE: 'CHARGE_DELETE_FAILURE',

  FETCH_CHARGE_BY_ID_REQUEST: 'FETCH_CHARGE_BY_ID_REQUEST',
  FETCH_CHARGE_BY_ID_SUCCESS: 'FETCH_CHARGE_BY_ID_SUCCESS',
  FETCH_CHARGE_BY_ID_FAILURE: 'FETCH_CHARGE_BY_ID_FAILURE',

  // Archive a charge
  CHARGE_ARCHIVE_REQUEST: 'CHARGE_ARCHIVE_REQUEST',
  CHARGE_ARCHIVE_SUCCESS: 'CHARGE_ARCHIVE_SUCCESS',
  CHARGE_ARCHIVE_FAILURE: 'CHARGE_ARCHIVE_FAILURE',

  // Unarchive a charge
  CHARGE_UNARCHIVE_REQUEST: 'CHARGE_UNARCHIVE_REQUEST',
  CHARGE_UNARCHIVE_SUCCESS: 'CHARGE_UNARCHIVE_SUCCESS',
  CHARGE_UNARCHIVE_FAILURE: 'CHARGE_UNARCHIVE_FAILURE',

  // Fetch charges summary
  CHARGES_SUMMARY_REQUEST: 'CHARGES_SUMMARY_REQUEST',
  CHARGES_SUMMARY_SUCCESS: 'CHARGES_SUMMARY_SUCCESS',
  CHARGES_SUMMARY_FAILURE: 'CHARGES_SUMMARY_FAILURE',
};

export default chargeConstants;